import React from 'react';

class RightMenuDetailsHelp extends React.Component {
    render() {
        return (
            <div className={'right-menu-details-container'} style={this.props.style}>
                <h5>
                    Mata do kodowania - siatka 10 na 10
                </h5>
                <p>
                    Bazowa kratownica składa się ze 100 pól. Oś pozioma oznaczona została za pomocą liter, natomiast oś
                    pionowa za pomocą cyfr. Po lewej stronie ekranu mamy możliwość wyboru elementów dodatkowych, z
                    których będziemy korzystać:
                </p>
                <ul>
                    <li>kolorowych kubeczków (10 kolorów do wyboru),</li>
                    <li>cyfr arabskich (od 0 do 9),</li>
                    <li>oraz wielu różnorodnych symboli</li>
                </ul>
                <p style={{'borderBottom': '1px solid white', 'paddingBottom': '2rem'}}>
                    Wybierając kolorowe kubki w łatwy sposób możemy stworzyć obrazki, które będą bazą do dyktand
                    graficznych lub tworzenia słownych instrukcji. Przenosimy je na matę klikając w wybrany przez nas
                    kolor, a następnie w wybrane przez nas pole na planszy. Kubeczek zostanie umieszczony na nim
                    automatycznie. Jeśli chcemy go usunąć wystarczy ponownie w niego kliknąć. Duży wybór symboli pozwala
                    tworzyć nieograniczoną liczbę wzorów, dopasowywać je do aktualnie realizowanego tematu i zakresu
                    materiału.
                </p>
                <h5>
                    Mata do kodowania - kolorowe kółka
                </h5>
                <p>
                    Wirtualna mata składa się z 9 kolorowych płaszczyzn. Każdą płaszczyznę tworzą koła w innym kolorze,
                    w sumie mamy 81 kół: 9 kolorów, po 9 z każdego koloru.
                    Tu również mamy do wyboru elementy dodatkowe znajdujące się po lewej stronie ekranu.
                </p>
            </div>
        )
    }
}

export default RightMenuDetailsHelp


// WEBPACK FOOTER //
// ./src/RightMenuDetailsHelp.js